// extracted by mini-css-extract-plugin
module.exports = {"modalFooter":"ModalFooter_modalFooter__3mBKh","modalFooterFlexLayout":"ModalFooter_modalFooterFlexLayout__1VIfY"};